import React from "react";

import PerformanceStarDateFilter from "../../../shared-screens/views/shared/performanceStarDateFilter";

/** Group performance star/date filter — shared filter with group card layout. */
const FilterComponent = (props) => {
  return (
    <PerformanceStarDateFilter
      {...props}
      cardClassName="notification-form shadow card px-3 mb-3"
      starSelectClassName="star-ranking rounded bg-secondary bg-opacity-25 w-50 w-md-25"
      useResponsiveStarWidth={false}
    />
  );
};

export default FilterComponent;
